import React from "react";
import HOC from "../../../components/HOC";
import AddReturWarehouse from "../../../components/screen/centralWarehouse/returWarehouse/AddReturWarehouse";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const AddReturnWarehousePage = () => {
  return (
    <div className="">
      <PageTemplate
        header="New Retur Warehouse"
        mainComponent={
          <ThemeProvider theme={theme}>
            <AddReturWarehouse />
          </ThemeProvider>
        }
        pageRole={36}
      />
    </div>
  );
};

export default HOC(AddReturnWarehousePage);
